import { render, staticRenderFns } from "./ValSectoresList.vue?vue&type=template&id=2a848154&"
import script from "./ValSectoresList.vue?vue&type=script&lang=js&"
export * from "./ValSectoresList.vue?vue&type=script&lang=js&"
import style0 from "./ValSectoresList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports